import { ILoggerOptions } from 'vuejs3-logger/dist/interfaces/logger-options';
import { LogLevels } from 'vuejs3-logger/dist/enum/log-levels';

const isProduction = import.meta.env.NODE_ENV === 'production';

export const loggingOptions: ILoggerOptions = {
    isEnabled: true,
    logLevel: isProduction ? LogLevels.ERROR : LogLevels.DEBUG,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};